import { useEffect } from "react";
import { useForm, validators } from "@hooks";
import { sunboundPayProxy } from '@proxies';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSpinnerContext } from '@contexts';
import { helpers } from "@shared";
import { Button, TextField } from "@common";

const ResendWelcome = () => {

    const initialState = { email: `` };
    const location = useLocation(), navigate = useNavigate();
    const { setSpinnerShow } = useSpinnerContext();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const validations = {
        email: (val: string) => validators.isValidEmail(val) || { email: `Please use a valid email address.` }
    };

    const handleSubmit = async (values: { email: string }) => {
        setSpinnerShow(true);
        try {
            const { email } = values;
            await sunboundPayProxy.resendWelcome(email);
            helpers.navigateNext(location, navigate, undefined, { email });

        } catch (error) {
            console.error(error);
        } finally {
            setSpinnerShow(false);
        }
    };

    const { values, errors, changeHandler, submitHandler } = useForm(initialState, {}, validations, handleSubmit);

    const isFormSubmittable = values.email && values.email.trim().length > 0;

    return (
        <div className="flex flex-col w-full">
            <div className="border-b border-neutral-100 pb-6 mb-6 md:mb-8">
                <h1 className="text-[20px] leading-[24px] md:text-[28px] md:leading-[40px] font-medium text-neutral-950 tracking-[0.2px] md:tracking-[0.28px]">
                    Something Went Wrong
                </h1>
            </div>
            <p className="text-sm leading-5 text-neutral-800 tracking-[0.14px] mb-6 md:mb-8">
                The invite link has expired. Enter the email used to sign up originally and we’ll send a new link.
            </p>
            <form method="POST" className="w-full flex flex-col gap-8" onSubmit={submitHandler} >
                <TextField
                    type="email"
                    name="email"
                    placeholder="Email*"
                    value={values.email}
                    onChange={changeHandler}
                    error={errors.email}
                />
                <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    className="w-full"
                    disabled={!isFormSubmittable}
                >
                    Continue
                </Button>
            </form>
        </div>
    );
};

export default ResendWelcome;
